export { default as GeneratePaymentLink } from './src/generate-payment-link';
